module.exports = __webpack_public_path__ + "media/images/default_org_thumb-e858c32c88a624ec94e93e980f8043fc.png";